import { render, staticRenderFns } from "./IncreaseNumber.vue?vue&type=template&id=1d307609&"
import script from "./IncreaseNumber.vue?vue&type=script&lang=js&"
export * from "./IncreaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d307609')) {
      api.createRecord('1d307609', component.options)
    } else {
      api.reload('1d307609', component.options)
    }
    module.hot.accept("./IncreaseNumber.vue?vue&type=template&id=1d307609&", function () {
      api.rerender('1d307609', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2sq3CvAhtDUsr/JS/comp/IncreaseNumber.vue"
export default component.exports